import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Raza`, method: 'GET', body: null, token: token})
}
